import { useMemo } from "react";
import Box from "@mui/joy/Box";
import { sanitizeFaqHtml } from "../../utils/faqHtml.js";

const ANSWER_SX = {
  color: "text.secondary",
  pb: 1.8,
  fontSize: "var(--joy-fontSize-sm, 0.875rem)",
  lineHeight: 1.7,
  overflowWrap: "anywhere",
  "& p": { m: 0, mb: 1 },
  "& > :last-child": { mb: 0 },
  "& strong, & b": { fontWeight: 700, color: "text.primary" },
  "& em, & i": { fontStyle: "italic" },
  "& u": { textDecoration: "underline" },
  "& a": {
    color: "#682243",
    textDecoration: "underline",
    textUnderlineOffset: "2px",
    fontWeight: 600,
  },
  "& a:focus-visible": { outline: "2px solid #682243", outlineOffset: "2px" },
  "& ul, & ol": { mt: 0, mb: 1, pl: "24px" },
  "& li": { mb: 0.5 },
  "& blockquote": {
    m: 0, mb: 1, pl: 1.5,
    borderLeft: "3px solid", borderColor: "divider",
  },
  "& mark": { color: "#202020", borderRadius: "2px", padding: "0 2px" },
  "& mark.marker-yellow": { backgroundColor: "hsl(60, 97%, 73%)" },
  "& mark.marker-green": { backgroundColor: "hsl(120, 93%, 68%)" },
  "& mark.marker-pink": { backgroundColor: "hsl(345, 96%, 73%)" },
};

export default function FaqAnswer({ answer, answerHtml }) {
  const safeHtml = useMemo(
    () => typeof answerHtml === "string" ? sanitizeFaqHtml(answerHtml) : null,
    [answerHtml],
  );

  // Совместимость со старым сервером: обычный текст экранирует сам React.
  if (safeHtml === null) {
    return <Box sx={{ ...ANSWER_SX, whiteSpace: "pre-wrap" }}>{answer || ""}</Box>;
  }

  return (
    <Box
      sx={{ ...ANSWER_SX, whiteSpace: "normal" }}
      dangerouslySetInnerHTML={{ __html: safeHtml }}
    />
  );
}